<template>
  <el-main class="common-main">
    <div class="container">
      <el-breadcrumb separator="/" class="common-nav">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>购物车</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="cart" v-loading="loading">
        <div class="cart-list" v-if="carts.length > 0">
          <div class="cart-item-header">
            <el-row :gutter="24">
              <el-col :span="2">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选
                </el-checkbox>
              </el-col>
              <el-col :span="4">
                图片
              </el-col>
              <el-col :span="9">
                课程
              </el-col>
              <el-col :span="4">
                科目
              </el-col>
              <el-col :span="3">
                金额
              </el-col>
              <el-col :span="2">
                操作
              </el-col>
            </el-row>
          </div>
          <div class="cart-item" v-for="(item, index) in carts" :key="index" v-if="item.study">
            <el-row :gutter="24">
              <el-col :span="2">
                <el-checkbox @change="changeCart" :checked="item.checked" v-model="item.checked"></el-checkbox>
              </el-col>
              <el-col :span="4">
                <img :src="item.study.images && item.study.images.length > 0 ? path + item.study.images[0] : noneImg" :alt="item.study.title" class="cart-item-img">
              </el-col>
              <el-col :span="9">
                <router-link :to="{path: '/course/'+item.study.id}" class="cart-item-title">
                  {{ item.study.title }}
                </router-link>
              </el-col>
              <el-col :span="4">
                <div class="cart-item-title">{{ item.course.title }}</div>
              </el-col>
              <el-col :span="3">
                <div class="cart-item-price">¥ {{ item.study.o_price }}</div>
              </el-col>
              <el-col :span="2">
                <el-button type="danger" size="mini" @click="removeCart(index)">移除</el-button>
              </el-col>
            </el-row>
          </div>
          <div class="cart-pay">
            <div class="cart-pay-num">
              <span>订单金额：</span>
              <span class="cart-pay-price">¥ {{ totalPrice }}</span>
            </div>
            <div>
              <span class="clear-cart" @click="clearCart">清除已选</span>
              <el-button type="primary" @click="goCheck">立即结算</el-button>
            </div>
          </div>
        </div>
        <div class="empty" v-if="empty">
          <div>
            <img src="../../static/images/empty.png" alt="购物车空空如也" class="empty-img">
            <div class="empty-title">购物车空空如也</div>
            <div class="empty-button">
              <el-button type="primary" @click="goCourse">去选课</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
import {authRequest} from "@/utils/request";
import ls from "@/utils/localStorage";

export default {
  name: "cartIndex",
  head() {
    return {
      title: '购物车'
    }
  },
  data() {
    return {
      carts: [],
      isIndeterminate: false,
      path: process.env.VUE_APP_FILE,
      checkAll: true,
      checkedCarts: [],
      loading: false,
      totalPrice: 0,
      empty: false,
      noneImg: process.env.VUE_APP_NONE
    }
  },
  created() {
    this.getCarts()
  },
  methods: {
    async getCarts() {
      this.loading = true
      try {
        let response = await authRequest('user/cart', {
          method: 'GET'
        })
        let carts = response.data.data
        carts.forEach((item, index) => {
          item.checked = true
        })
        if (carts.length === 0) {
          this.empty = true
        }
        this.carts = carts
        this.loading = false
        this.countTotal()
      } catch (e) {

      }
    },
    handleCheckAllChange(val) {
      this.carts.forEach((item, index) => {
        item.checked = val
      })
      this.isIndeterminate = false
      this.countTotal()
    },
    changeCart(val) {
      let count = 0
      this.carts.forEach((item, index) => {
        if (item.checked === true) {
          count++
        }
      })
      this.isIndeterminate = count > 0 && count < this.carts.length
      this.checkAll = count === this.carts.length
      this.countTotal()
    },
    async removeCart(index) {
      try {
        let response = await authRequest('cart/' + this.carts[index].id, {
          method: 'DELETE'
        })
        if (response.status === 204) {
          this.$message.success('已移除该课程')
          this.carts.splice(index, 1)
          this.empty = this.carts.length === 0
          this.countTotal()
        }
      } catch (e) {

      }
    },
    countTotal() {
      var total = 0;
      for (var i = 0; i < this.carts.length; i++) {
        if (this.carts[i].checked && this.carts[i].study) {
          total += Number(this.carts[i].study.o_price) * 100
        }
      }
      this.totalPrice = total / 100
    },
    goCourse() {
      this.$router.push({name: 'course'})
    },
    goCheck() {
      let count = 0
      this.carts.forEach((item, index) => {
        if (item.checked === true) {
          count++
        }
      })
      if (count === 0) {
        this.$message.warning('请至少选择一科结算')
        return false
      }
      let result = []
      for (var i = 0; i < this.carts.length; i++){
        if (this.carts[i].checked) {
          result.push(this.carts[i])
        }
      }
      ls.setItem('order', result)
      this.$router.push({name: 'order'})
    },
    clearCart() {
      let result = []
      for (var i = 0; i < this.carts.length; i++){
        if (this.carts[i].checked) {
          result.push(this.carts[i].id)
        }
      }
      if (result.length <= 0) {
        this.$message.warning('当前未选中购物车中任何课程')
        return false
      }
      this.$confirm('您确定清除已选的课程吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(async () => {
        try {
          await authRequest('card/batch/delete', {
            method: 'POST',
            data: {
              ids: result
            }
          })
          this.$message.success('清除成功')
          this.getCarts()
        } catch (e) {

        }
      }).catch(() => {

      });
    }
  }
}
</script>

<style scoped>
.cart {
  padding: 20px;
  background-color: #ffffff;
  border-radius: 5px;
}

.cart-item-header {
  color: #333333;
  font-size: 14px;
  font-weight: 500;
  padding-bottom: 20px;
  border-bottom: 1px solid #f3f3f3;
}

.cart-item {
  border-bottom: 1px dashed #ebebeb;
  padding: 20px 0;
  font-size: 14px;
}

.cart-item-img {
  width: 150px;
  height: 82px;
  object-fit: cover;
  border-radius: 5px;
}

.cart-item-price {
  color: #f44848;
  font-size: 18px;
}

.cart-pay {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  align-items: center;
}

.cart-pay-num {
  font-size: 14px;
  color: #333333;
}

.cart-pay-price {
  font-size: 20px;
  color: #f44848;
}

.clear-cart{
  margin-right: 20px;
  color: #666666;
  font-size: 13px;
  cursor: pointer;
}

.clear-cart:hover{
  color: #f44848;
}
</style>
